"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlWithKey = void 0;
function getUrlWithKey(key) {
    return `https://r2.vinoai.net/${key}`;
}
exports.getUrlWithKey = getUrlWithKey;
